import script from "./ToggleButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ToggleButton.vue?vue&type=script&setup=true&lang=js"

import "./ToggleButton.vue?vue&type=style&index=0&id=a82e0326&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a82e0326"]])

export default __exports__